import { type DeleteApiDonationsByUserIdDonationsDonationidPathParams } from '@/shared/api'
import { showNotificationSuccessFx } from '@/shared/lib/providers'
import { createEvent, sample } from 'effector'

import { donationDelete } from '../api'

export const donationDeleted = createEvent<{
  id: DeleteApiDonationsByUserIdDonationsDonationidPathParams['Id']
  donationId: DeleteApiDonationsByUserIdDonationsDonationidPathParams['DonationId']
}>()

sample({
  clock: donationDeleted,
  target: donationDelete.start,
})

sample({
  clock: donationDelete.finished.success,
  fn: () => ({ message: 'Пожертвование успешно возвращено' }),
  target: showNotificationSuccessFx,
})
